<template>
  <div id="Loan">
    <LoanInvesting
      :leftAmount="leftAmount" :leftMarketingAmount="leftMarketingAmount" :possibleAmount="possibleAmount" :offer="offer" :status="status" v-if="isLoanInvesting"/>
    <template v-else>
      <div class="title">
        이용 가능 금액
        <PossibleAmountGuideDialogButton />
      </div>
      <div class="amount">
        <Amount
          :amount="possibleAmount"
          :offerStatus="offer ? offer.status : 0"
        />
      </div>
      <div class="button">
        <v-btn v-if="mode !== 'production'" style="color:white;" :to="{path: '/woori-crowd', query: { autoRedirect: false } }" block large color="#1baaf1">
          우리동네 크라우드 펀딩 신청
        </v-btn>
        <v-btn v-else to="/woori-crowd" style="color:white;" block large color="#1baaf1">
          우리동네 크라우드 펀딩 신청
        </v-btn>
        <!-- <button
          @click="applyLoan"
          :disabled="!isLoanAvailable || isLoading || possibleAmount < minimumPossibleAmount || !isKycCompleted || !isCertificatedIncomeAmount"
          v-if="isApplyLoanAvaliable"
        >
          <span v-html="status.down"></span>
          <v-progress-circular
            v-if="isLoading"
            style="padding-left: 15px;"
            size="24"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </button>
        <button @click="status.route ? $router.push({ name: status.route }) : ''" :disabled="isDownButtonDisabled" v-else >{{ status.down }}</button> -->
      </div>
    </template>
    <div class="summary" v-if="!getStatusInProgress">
      <div class="notice-wrapper">
        <p class="notice">* 주말의 경우 금,토,일요일 매출이 반영되지 않아<br /> 평소보다적은 한도로 산출 될 수 있습니다.</p>
      </div>
      <!-- <div v-if="isRepaymentDataLoading">
          <div class="notice-wrapper">
            <p class="notice"> 대출정보 업데이트 중 (약 5초 소요예정)
              <v-progress-circular
                  v-if="isRepaymentDataLoading"
                  style="padding-left: 15px;"
                  size="24"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
            </p>
          </div>
      </div> -->
      <div>
        <dl>
          <dt>대출잔액 ({{ totalLoanCount }} 건)</dt>
          <dd><span>{{ leftAmount | toCurrency }}</span> 원</dd>
        </dl>
        <dl v-if="marketingCount > 0">
          <dt>마케팅론 ({{ marketingCount }} 건)</dt>
          <dd><span>{{ leftMarketingAmount | toCurrency }}</span> 원</dd>
        </dl>
        <dl>
          <dt>총한도</dt>
          <dd>
            <span>{{ offer ? offer.amount : 0 | toCurrency }}</span> 원
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'

import LoanService from '@/service/loan/LoanService'
import StatusService from '@/service/status/StatusService'

import LoanInvesting from './LoanInvesting'
import PossibleAmountGuideDialogButton from './components/amount/PossibleAmountGuideDialogButton'
import Amount from './components/Amount'

import { sleep } from '@/util'

const UNIT = 10000

export default {
  name: 'Loan',
  components: {
    LoanInvesting,
    Amount,
    PossibleAmountGuideDialogButton,
  },
  props: {
    status: {
      type: Object
    },
    getStatusInProgress: {
      type: Boolean
    }
  },
  data() {
    return {
      isRepaymentDataLoading: true,
      isLoading: false,
      isContractLoading: false,
      investingAmount: 0,
      investingAmountRate: 0.0,
      isLoanAvailable: false,
      minimumPossibleAmount: LoanService.MINIMUM_POSSIBLE_AMOUNT,
      statuesExecutable: StatusService.statusesSet.statuesExecutable,
      statuesInvesting: StatusService.statusesSet.statuesInvesting,
      statuesExecuted: StatusService.statusesSet.statuesExecuted,
      statuesReexecutable: StatusService.statusesSet.statuesReexecutable,
    }
  },
  async created() {
    let loanAvailableObject = await LoanService.isLoanAvailable()
    this.isLoanAvailable = loanAvailableObject.can_loan
    // 대출 신청 가능한 상태일때
    if (this.statuesExecutable.includes(this.status.code)) {
      // 신청 가능한 시간이 아닐때
      if (!this.isLoanAvailable) {
        // 주말 대출 신청 오픈
        this.status.down = loanAvailableObject.message
        // this.status.down = '평일 10시~16시에 신청가능'
      } else if (!this.isCertificatedIncomeAmount) {
        // 소금원 없는 경우
        this.status.down = '소득금액증명원을 제출해주세요.'
      }
    }

    if (this.user.kyc.id_card_verification_is_done && !this.user.kyc.id_card_image_verified) {
      this.status.down = '고객확인의무에 따른 자격여부를 검증하고 있습니다. 약 1영업일 이내 처리 될 예정입니다.'
    }

    // await this.getLoanCount()
  },
  computed: {
    ...mapState('env', ['mode']),
    ...mapGetters('auth', {
      user: 'getProfile'
    }),
    ...mapGetters('loan', {
      offer: 'getOffer'
    }),
    ...mapGetters('loan', {
      loan: 'getLoanData'
    }),
    ...mapGetters('loan', {
      leftAmount: 'getLeftAmount'
    }),
    ...mapGetters('loan', {
      leftMarketingAmount: 'getLeftMarketingAmount'
    }),
    ...mapGetters('loan', {
      marketingCount: 'getMarketingCount'
    }),
    ...mapGetters('loan', {
      totalLoanCount: 'getTotalLoanCount'
    }),
    ...mapGetters('loan', {
      loansRepayment: 'getLoansRepayment'
    }),
    isDownButtonDisabled() {
      // 대출 신청 외의 버튼에 대해 비활성화로 보여줄지 여부
      // 당장은 여신협회 계정 이상인 케이스만 비활성화 적용
      // NOT_CFA_ACCOUNT
      return this.status.code === 'not_cfa_account' || this.status.code === 'executed_today'
    },
    isApplyLoanAvaliable() {
      return this.statuesExecutable.includes(this.status.code)
    },
    isLoanInvesting() {
      return this.statuesInvesting.includes(this.status.code)
    },
    possibleAmount() {
      let possibleAmount = (this.offer) ? this.offer.amount : 0
      if (this.statuesExecuted.includes(this.status.code)) {
        possibleAmount = 0
      } else if (this.statuesReexecutable.includes(this.status.code)) {
        let amountAdditional = (possibleAmount - this.leftAmount) | 0
        possibleAmount = (amountAdditional >= this.minimumPossibleAmount) ? amountAdditional : 0
      }
      return Math.floor(possibleAmount / UNIT) * UNIT
    },
    isKycCompleted() {
      if (!this.user || !this.user.kyc) {
        return false
      }
      return this.user.kyc.id_card_verification_is_done === true && this.user.kyc.id_card_image_verified === true
    },
    isCertificatedIncomeAmount() {
      if (!this.user || !this.user.documents) {
        return false
      }
      return this.user.documents.truth_or_falsehood_of_certificate_of_income_amount === true
    }
  },
  watch: {
    loansRepayment(newVal, oldVal) {
      this.isRepaymentDataLoading = false
      console.log('loansRepayment Watch ', newVal)
      // let loan = newVal.filter((loan) => loan.status === 'executed' && loan.type === 'normal')
      // let loanMarkting = newVal.filter((loan) => loan.status === 'executed' && loan.type === 'marketing')
      // this.totalLoanCount = loan.length
      // this.marketingCount = loanMarkting.length
    }
  },
  methods: {
    // async getLoanCount() {
    //   let data = await LoanService.getLoanOngoingForRepayment()
    //   let loan = data.filter((loan) => loan.status === 'executed' && loan.type === 'normal')
    //   let loanMarkting = data.filter((loan) => loan.status === 'executed' && loan.type === 'marketing')
    //   this.totalLoanCount = loan.length
    //   this.marketingCount = loanMarkting.length
    // },
    async applyLoan() {
      if (this.isLoading === true) {
        return
      }

      try {
        this.isLoading = true

        if (!this.isKycCompleted) {
          this.$swal.fire({
            html: '본인확인 절차가 완료되어야<br> 비상금 신청이 가능합니다.',
            confirmButtonText: '확인'
          })
          return
        }
        if (!this.isCertificatedIncomeAmount) {
          this.$swal.fire({
            html: '소득금액증명원 확인이 완료되어야<br> 비상금 신청이 가능합니다.',
            confirmButtonText: '확인'
          })
          return
        }

        await LoanService.applyLoan(this.possibleAmount)
      } catch (e) {
        // 오류시 대기
        await sleep(4000)

        if (e) {
          this.$swal.fire({
            html: '신청에 문제가 발생했습니다! 다시 시도해주세요.<br />문제가 지속될 시 고객센터로 문의주세요.',
            confirmButtonText: '확인'
          })
        }
      } finally {
        this.isLoading = false
      }
    },
  }
}
</script>

<style lang="scss" scoped>
#Loan {
  margin-top: 35px;
  margin-bottom: 30px;

  .button {
    margin-top: 25px;

    button {
      width: 100%;
      color: #ffffff;
      background-color: #1baaf1;
      height: 50px;
      border-radius: 6px;
      font-weight: 700;
    }
  }

  .summary {
    margin-top: 18px;
    .notice-wrapper {
      text-align: center;
      .notice {
        margin-bottom: 16px;
        font-size: 14px;
      }
    }

    dl {
      display: flex;
      justify-content: space-between;
      margin-bottom: 14px;

      dt {
        font-size: 15px;
        font-weight: 600;
        color: #6e7c91;
      }

      dd {
        font-size: 17px;
        font-weight: 900;
        letter-spacing: -0.5px;
        color: #16191d;
      }
    }
  }
}
</style>
